import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        deliveryAddresses: {
          module: () => import('./container/delivery-addresses/delivery-addresses.module').then((m) => m.DeliveryAddressesModule),
          cmsComponents: ['CmsDeliveryAddressesComponent'],
        },
      },
    }),
  ],
})
export class DeliveryAddressesFeatureModule {}
